import { isSmallSpace } from 'utils/grid';
import {
  SectionDragPreviewLabel,
  SectionDragPreviewLabelInput,
  SpaceDragPreviewLabel,
  SpaceDragPreviewLabelInput
} from 'utils/space-label-drag-preview-types';
import { resolveSpaceLabelFit } from 'utils/space-label-fit';
import { resolveSpaceLabelLayout } from 'utils/space-label-layout';
import { spaceRectVertices } from 'utils/space-label-position';
import { isPolygonGridSpace } from 'utils/space-polygon';

export const NEW_SPACE_PREVIEW_WIDTH_PX = 100;
export const NEW_SPACE_PREVIEW_HEIGHT_PX = 60;

function fallbackAnchor(widthPx: number, heightPx: number) {
  return {
    x: widthPx / 2,
    y: heightPx / 2
  };
}

export function resolveSpaceDragPreviewLabel(
  input: SpaceDragPreviewLabelInput
): SpaceDragPreviewLabel {
  const isPolygon = isPolygonGridSpace(
    input.vertices,
    input.widthPx,
    input.heightPx
  );
  const vertices =
    isPolygon && input.vertices
      ? input.vertices
      : spaceRectVertices(input.widthPx, input.heightPx);
  const layout = resolveSpaceLabelLayout({
    label: input.label,
    spaceWidth: input.widthPx,
    spaceHeight: input.heightPx,
    zoom: input.zoom,
    allowWrap: !isSmallSpace(input.widthPx, input.heightPx),
    vertices
  });

  return {
    displayLabel: layout.displayLabel,
    anchor: layout.anchor ?? fallbackAnchor(input.widthPx, input.heightPx),
    screenMaxWidth: layout.screenMaxWidth
  };
}

export function resolveSectionDragPreviewLabel(
  input: SectionDragPreviewLabelInput
): SectionDragPreviewLabel {
  const fit = resolveSpaceLabelFit({
    label: input.label,
    spaceWidth: input.boundsWidth,
    spaceHeight: input.boundsHeight,
    zoom: input.zoom,
    allowWrap: true
  });

  return {
    displayLabel: fit.displayLabel
  };
}
